export default __webpack_public_path__ + "static/media/memories.05c07818.png";